import React from "react";
import { Text, Xs } from "../../common";
import { VictoryContainer, VictoryLabel, VictoryPie } from "victory";
import moment from "moment";
import { dashboardTailwindExtensions } from "../../../styles/dashboardTailwindExtensions";

const GAUGE_COLORS = [
  dashboardTailwindExtensions.colors["green-primary"],
  dashboardTailwindExtensions.colors["gray-secondary"]
];

const DEFAULT_FONT_FAMILY = "Gilroy, sans-serif";

const MIN_CREDIT_SCORE = 300;
const MIN_CREDIT_SCORE_LABEL = String(MIN_CREDIT_SCORE);
const MAX_CREDIT_SCORE = 850;
const MAX_CREDIT_SCORE_LABEL = String(MAX_CREDIT_SCORE);

const CreditScore = ({ className }) => {
  const current_score = null;
  let current_score_label = "N/A";

  const next_update_date = moment().add(1, "months");
  const next_update_date_formatted = next_update_date.format("MMMM YYYY");
  const next_update_label = "Next Update: ";

  const gauge_data = [
    {
      x: "score",
      y: current_score - MIN_CREDIT_SCORE,
      label: MIN_CREDIT_SCORE_LABEL
    },
    {
      x: "score_remainder",
      y: MAX_CREDIT_SCORE - current_score,
      label: MAX_CREDIT_SCORE_LABEL
    }
  ];

  return (
    <div className={`${className} w-2/5`}>
      <div className="flex rounded-sm common-container h-auto min-h-full">
        <div className="flex flex-col items-center text-center justify-center w-1/2 md:pr-5 pr-2">
          <Text title>Your Credit Score</Text>
          <Text className="text-xs pt-2">
            <span className="font-bold">{next_update_label}</span>
            <Xs to="md">
              <br />
            </Xs>
            {next_update_date_formatted}
          </Text>
        </div>
        <div className="flex flex-col w-1/2 text-center items-center justify-center">
          <VictoryContainer width={115} height={115} responsive={false}>
            <VictoryPie
              width={115}
              height={115}
              colorScale={GAUGE_COLORS}
              standalone={false}
              startAngle={-120}
              endAngle={120}
              data={gauge_data}
              innerRadius={45}
              labelPosition={({ index }) =>
                index === 0 ? "startAngle" : "endAngle"
              }
              labelComponent={<VictoryLabel textAnchor="middle" dy={10} />}
              labelRadius={55}
              padding={{ top: 0, bottom: -5, left: 0, right: 0 }}
              style={{
                labels: { fontSize: 12, fontFamily: DEFAULT_FONT_FAMILY }
              }}
            />
            <VictoryLabel
              textAnchor="middle"
              style={{ fontSize: 30, fontFamily: DEFAULT_FONT_FAMILY }}
              x={57.5}
              y={57.5}
              text={current_score_label}
            />
          </VictoryContainer>
        </div>
      </div>
    </div>
  );
};

export default CreditScore;
